import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { extend } from 'vee-validate'
import {
  required, numeric, double, min_value, max_value
} from 'vee-validate/dist/rules'

//  pick your app languages from the list
//  https://github.com/logaretm/vee-validate/tree/master/locale

import enVee from 'vee-validate/dist/locale/en'

import { deepCopy } from './utils'

const veeMsgs = {
  en: enVee,
}

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
      if (veeMsgs[locale]) {
        messages[locale]['validations'] = deepCopy(veeMsgs[locale].messages)
      }
    }
  })
  return messages
}

const defaultMessage = (field, values) => {
  return i18n.t(`validations.${values._rule_}`, values)
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
})

extend('required', {
  ...required,
  message: defaultMessage,
})

extend('uniqueLocation', () => `Location name must be unique`)  


extend('numeric', {
  ...numeric,
  message: defaultMessage,
})

extend("min_value", {
  ...min_value,
  message: defaultMessage
});

extend("max_value", {
  ...max_value,
  message: defaultMessage
});

extend("double", {
  ...double,
  validate: (value, params) => {
    // in case of 2 decimals it valid with 1 decimal also
    if (params.decimals === "2") {
      return numeric.validate(value)
        || double.validate(value, params)
        || double.validate(value, { ...params, decimals: "1" })
    }
    return numeric.validate(value) || double.validate(value, params)
  },
  message: defaultMessage
});

export default i18n
